import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';
import { IncidentService } from '../../../core/services/hezky-be-services/incident.service';

@Component({
  selector: 'app-incident-card',
  templateUrl: './incident-card.component.html',
})
export class IncidentCardComponent implements OnChanges {
  @Input({ required: true }) incident: any;
  @Output() onCardClick = new EventEmitter();
  window: number = window.innerWidth;

  constructor(public feUtil: FeUtil, public incidentService: IncidentService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['incident']) {
      this.incident = changes['incident'].currentValue;
      this.incident['incident_type'] = this.incident['incident_type'].toLowerCase();
    }
  }

  protected emitCardClick(incident: any) {
    this.onCardClick.emit(incident);
  }
}
